import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    file: null,
    fileUrl: null,
    uploadedAt: null
}

const uploadReducer = createSlice({
    name: 'upload',
    initialState,
    reducers: {
        setUploadedFile: (state, action) => {
            console.log('action', action)
            state.file = action.payload.file
            state.fileUrl = action.payload.url
            state.uploadedAt = new Date().toISOString()
        },
        resetUploadedFile: () => initialState
    }
})

export const { setUploadedFile, resetUploadedFile } = uploadReducer.actions

export default uploadReducer.reducer
